import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "AI Engineer",
          "Data Scientist",
          "GenAI Developer",
          "LLM Specialist",
          "RAG Expert",
          "Deep Learning Engineer",
          "Machine Learning Engineer",
          "AI Agent Developer",
          "Natural Language Processing Expert",
          "Computer Vision Engineer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
